import { EActionType, IAction, IState } from '@mfe-types/context';

export const reducer = (state: IState, action: IAction): IState => {
    const { type } = action;

    switch (type) {
        case EActionType.SetCurrentStep:
            return {
                ...state,
                currentStep: action.payload,
            };
        case EActionType.SetSpecificTitle:
            return {
                ...state,
                specificTitle: action.payload,
            };
        case EActionType.SetStepValues:
            return {
                ...state,
                formValues: {
                    ...state.formValues,
                    ...action.payload,
                },
            };
        case EActionType.SetToastMessage:
            return {
                ...state,
                toastMessage: action.payload,
            };
        case EActionType.SetUserVerification:
            return {
                ...state,
                userVerification: action.payload,
            };
        case EActionType.SetEstimations:
            return {
                ...state,
                estimations: action.payload,
            };
        case EActionType.SetCities:
            return {
                ...state,
                cities: action.payload,
            };
        case EActionType.SetIsFromUpdatePage:
            return {
                ...state,
                isFromUpdatePage: action.payload,
            };
        case EActionType.SetIsAuthenticated:
            return {
                ...state,
                isAuthenticated: action.payload,
            };
        case EActionType.SetHasSubmittedCurrentStep:
            return {
                ...state,
                hasSubmittedCurrentStep: action.payload,
            };
        case EActionType.SetHasSubmittedPriceEstimateFeedback:
            return {
                ...state,
                hasSubmittedPriceEstimateFeedback: action.payload,
            };
        case EActionType.SetHasUpdatedPhoneNumber:
            return {
                ...state,
                hasUpdatedPhoneNumber: action.payload,
            };
        default:
            return state;
    }
};
